
import { Vue, Component } from "vue-property-decorator";
import Pagination from "@/components/Pagination/index.vue";
import { faceTempleteService } from "@/api/payments/faceTempleteService";

import PagedListBase, {
  PagedRequestDto,
} from "@/lib/view-base/paged-list-base";
import { UserDto, VipPaymentRecordDto } from "@/api/service-proxies";

class PageFaceTempleteVipPaymentRecordRequest extends PagedRequestDto {
  faceTempleteId: number;
}

@Component({
  components: {
    Pagination,
  },
})
export default class PaymentPayments extends PagedListBase<
  PageFaceTempleteVipPaymentRecordRequest,
  VipPaymentRecordDto
> {
  request = new PageFaceTempleteVipPaymentRecordRequest();
  selectedFaceTempletes = [];
  created() {
    this.request.faceTempleteId = <number>(<unknown>this.$route.params["id"]);
    this.refresh();
  }

  getpage(finishCallback: Function): void {
    faceTempleteService
      .getPagedFaceTempleteVipPaymentRecord(
        this.request.faceTempleteId,
        this.request.sorting,
        this.request.skipCount,
        this.request.maxResultCount
      )
      .then((result) => {
        this.list = result.items;
        this.showPaging(result);
      })
      .finally(() => {
        finishCallback();
      });
  }
}
